import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { image } from "html2canvas/dist/types/css/types/image";
import { LoginService } from "./login.service";
import { AuthService } from "./auth.service";
import { Observable, BehaviorSubject } from "rxjs";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent {
  public formGroup: FormGroup;
  isLogin: Observable<boolean>;
  public spinnerName: string;
  public spinnerType: string;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private httpLogin: LoginService,
    private authService: AuthService,
    private spinner: NgxSpinnerService
  ) {
    this.isLogin = new BehaviorSubject<boolean>(false);
    this.authService.isLoggedIn.subscribe((c) => {});
  }

  public ngOnInit() {
    this.spinnerName = "spinnerLogin";
    //this.spinnerType = "square-spin";
    this.spinnerType = "ball-clip'rotate";
    if (localStorage.getItem("codigo")) {
      this.router.navigate(["/"]);
    }
    this.buildForm();
  }
  private buildForm() {
    this.formGroup = this.formBuilder.group({
      usuarioNombre: "",
      usuarioContrasenia: "",
      app: "HCG",
    });
  }

  login() {
    this.spinner.show(this.spinnerName);
    this.httpLogin.getLogin(this.formGroup.value).subscribe(
      (response) => {
        if (response && response.token) {
          try {
            // Decodificar el token
            const decodedToken = this.httpLogin.decodeToken(response.token);

            if (decodedToken) {
              // Acceder a los valores usando notación de corchetes
              const usuarioControlId = decodedToken["usuarioControlId"];
              const usuarioControlUsuario =
                decodedToken["usuarioControlUsuario"];

              if (usuarioControlId && usuarioControlUsuario) {
                localStorage.setItem("codigo", usuarioControlUsuario);
                localStorage.setItem("id", usuarioControlId);
                localStorage.setItem("tipo", "HCGCONTROL");
                localStorage.setItem("token", response.token);
                this.spinner.hide(this.spinnerName);
                window.location.reload();
                this.authService.loginInicial();
              } else {
                throw new Error("Token no válido: faltan propiedades.");
              }
            } else {
              throw new Error("Token no decodificado correctamente.");
            }
          } catch (error) {
            alert("Error: " + error.message);
            this.spinner.hide(this.spinnerName);
          }
        } else {
          alert("Vuelva ingresar sus credenciales!!!");
          this.spinner.hide(this.spinnerName);
        }
      },
      (error) => {
        alert("Vuelva ingresar sus credenciales!!!");
        this.spinner.hide(this.spinnerName);
        console.error(error);
      }
    );
  }
}
